<!--  阅读记忆组件 -->
<template>
  <div id="">
    <div
      v-if="dialogTableVisible"
      id="historyPan"
      style="height: 80vh; overflow: hidden; position: relative;"
    >
      <el-scrollbar id="historybar">
        <el-table :data="gridData" :fit="true">
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column label="图名" width="300">
            <template #default="scope">
              <span
                @click="openBigImg(scope.$index, scope.row)"
                class="hisIname"
              >
                {{ scope.row.iName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="来源">
            <template #default="scope">
              <span @click="openBigImg(scope.$index, scope.row)" class="isrc">
                {{ scope.row.iSrc.replace(/@/g, '') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogTableVisible: false,
      gridData: []
    }
  },
  methods: {
    openBigImg: async function (index, row) {
      if ((await this.judgeNowUserHasPowerOrNotFun()) === false) {
        return
      }

      // alert(index + '---' + row)
      this.dialogTableVisible = false
      let imgInfo =
        row.iName + ':' + row.iSrc + ':' + row.iDraw + ':' + row.iMark + ':'
      imgInfo =
        imgInfo + row.iClass + ':' + row.titleG + ':' + row.clearBG + ':' // 新增的3个属性
      this.$store.commit('setGlobalObjOfShowImgID', row.iId)
      this.$store.commit('setGlobalObjOfShowImgInfo', imgInfo)
      this.$router
        .push({
          path: '/imgList/convas',
          query: {
            showImage: true,
            fromRoutePath: encodeURIComponent('/userCenter/history')
          }
        })
        .catch(() => {})
    },
    judgeNowUserHasPowerOrNotFun: async function () {
      const api = '/md/front/paid/image/multiSearch'
      const res = await this.axios.post(api)
      if (res.status !== 200) {
        return false
      }
      if (res.data.flag) {
        return true
      } else {
        this.$alert(res.data.info, '提示')
        return false
      }
    },
    showHistoryDialog () {
      this.dialogTableVisible = true
      const api = '/md/front/additional/history/list'
      this.axios.post(api).then(res => {
        if (res.status === 200) {
          // 加载成功
          const vlist = res.data
          let person
          const list = []
          for (let i = 0; i < vlist.length; i++) {
            person = {}
            const vstr = vlist[i].rhImageInfo
            let varray = []
            varray = vstr.split(':')

            if (varray.length === 9) {
              person.iId = varray[0]
              person.iName = varray[1]
              person.iSrc = varray[2]
              if (varray[3] === 'null') {
                person.iMark = ''
              } else {
                person.iMark = varray[3]
              }
              if (varray[4] === 'null') {
                person.iDraw = ''
              } else {
                person.iDraw = varray[4]
              }
              person.iClass = varray[5]
              person.titleG = varray[6]
              person.clearBG = varray[7]

              list.push(person)
            }
          }
          this.gridData = list
        }
      })
      // rhId: 18, userId: 5, rhImageInfo: "400001900014:篁墩圖:篁墩程朱闕里祠志8卷清乾隆愛餘書屋刻本:null:null:", rhReadDate: "2020-05-06T16:31:52"
    }
  },
  mounted () {
    this.showHistoryDialog()
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

#historyPan {
  position: relative;
}
#historyPan > .el-scrollbar {
  height: 100%;
  width: 100%;
}

.hisIname {
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  color: #000;
}
.isrc {
  cursor: pointer;
}
#historybar :deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
</style>
